export const STATIC_MEDIA_DOMAIN = 'https://static-media.meetfrank.com';
export const PRICING_PAGE = 'https://meetfrank.com/business/pricing';
export const MEETFRANK_BLOG = 'https://meetfrank.com/blog/';
export const COMPENSATION_APP_URL = 'https://compensation.app';
export const MEETFRANK_ADMIN_URL = 'https://meetfrank.com/admin';

// Links
export const MEETFRANK_BLOG_NIKOLAI_KABATSIKOV =
  'https://meetfrank.com/blog/hr/interview-nikolai-kabatsikov-head-of-talent-at-bolt/';
export const HOW_MEETFRANK_WORKS_URL = 'https://intercom.help/meetfrank/en/articles/6271857-how-meetfrank-works';
export const HOW_VIRTUAL_RECRUITER_WORKS_URL =
  'https://meetfrank.com/blog/announcements/how-meetfranks-virtual-recruiter-works/';
